import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchProducts } from '../../../../actions/product/productList'
import Products from '../Products'
import { AppState } from '../../../../reducers'
import { FiltersBar, FilterTextField } from '../../../Utils/Filters/Filter'
import { useTranslation } from 'react-i18next'
import { ProductListState } from '../../../../reducers/product/productList'
import { Button, Stack } from '@mui/material'
import Product from '../../../../models/Product'
import { FilterStatusProduct } from '../../../Utils/Filters'

interface Props {
  fullInfo?: boolean
  productList: ProductListState
}

const ProductList: React.FC<Props> = ({ productList }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation('product')
  const [edit,] = useState(false)

  useEffect(() => {
    dispatch(fetchProducts(history.location.search))
  }, [dispatch, history.location.search, edit])


  const linkToProductEdit = (product: Product) => {
    const editUrl = `/admin/products/update/${product.id}`
    history.push(editUrl, { update: edit })
  }

  return (
    <div>
      <FiltersBar>
        <FilterTextField style={{marginRight:"10px"}} name="code" label={t("code")} />
        <FilterTextField style={{maxWidth:"400px", width:"400px", marginRight:"10px"}} name="description" label={t("description")} />
        <FilterTextField style={{maxWidth:"400px", width:"400px"}} name="information" label={t("information")} />
        <FilterStatusProduct name="status" label={t("status")} />
      </FiltersBar>
      <Products
        rows={(productList.products || []).map(s => ({ data: s }))}
        loading={productList.isFetching}
        pagination={productList.pagination || undefined}
        onClickInfo={linkToProductEdit}
      />

      <Stack display="flex" flexDirection='row' justifyContent="space-between" padding="10px">
        <Button aria-label="back" size='large' style={{ textTransform: 'none' }}  onClick={() => history.push('/admin/products/create', { title: t('create') })}>
        {`${t('create')}${t('product')}`}
        </Button>
      </Stack>
    </div>
  )
}

const mapStateToProps = (state: AppState) => ({
  productList: state.productList,
})

export default connect(mapStateToProps, null)(ProductList)